import _ from 'underscore';

/**
 * Given a URL where search or hash strings can contain key/value pairs, return all the pairs.
 * @param {String} href - location.href
 * @returns {Object} - Keys and values needed for OAuth.
 */
export function parseUrlSearchAndHashParams(href) {
  const params = {};

  const url = new URL(href);

  const searchParams = new URLSearchParams(url.search);
  searchParams.forEach((value, key) => {
    params[key] = value;
  });

  const hashParamsStartIndex = url.hash && url.hash.indexOf('?');

  if (_.isFinite(hashParamsStartIndex) && hashParamsStartIndex >= 0) {
    const hashParams = new URLSearchParams(url.hash.substring(hashParamsStartIndex));
    hashParams.forEach((value, key) => {
      params[key] = value;
    });
  }

  return params;
}
